/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TRestoreOfferWebsiteModel,
  IRestoreOfferWebsiteRequest,
  IMappers,
  IRestoreOfferWebsiteResponse,
  IRestoreOfferWebsiteResponseError,
  TRestoreOfferWebsiteResponse,
} from './types';

const defaultConfig: TRestoreOfferWebsiteModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'hidden-objects',
  pathApi: '/v1/restore-offer-website/',
  hostType: 'api',
} as TRestoreOfferWebsiteModel;

function createRestoreOfferWebsiteModel(parameters: IRestoreOfferWebsiteRequest): TRestoreOfferWebsiteModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IRestoreOfferWebsiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IRestoreOfferWebsiteRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchRestoreOfferWebsite<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IRestoreOfferWebsiteOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TRestoreOfferWebsiteResponse
> {
  const { response, statusCode } = await httpApi.fetch(createRestoreOfferWebsiteModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IRestoreOfferWebsiteResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IRestoreOfferWebsiteResponseError);
    }
  }

  return { response, statusCode } as TRestoreOfferWebsiteResponse;
}

export { defaultConfig, createRestoreOfferWebsiteModel, fetchRestoreOfferWebsite };
